import React, {Component} from 'react';
import {Trans} from "@lingui/macro";

export default class extends Component {
    render() {
        const { value } = this.props;

        let text;
        switch (value) {
            case 'bank_cash':
                text = <Trans>Bank & Cash</Trans>;
                break;
            case 'accounts_receivable':
                text = <Trans>Accounts Receivable</Trans>;
                break;
            case 'accounts_payable':
                text = <Trans>Accounts Payable</Trans>;
                break;
            case 'inventory':
                text = <Trans>Inventory</Trans>;
                break;
            case 'fixed_assets':
                text = <Trans>Fixed Assets</Trans>;
                break;
            case 'credit_card':
                text = <Trans>Credit Card</Trans>;
                break;
            case 'retained_earnings':
                text = <Trans>Retained Earnings</Trans>;
                break;
            case 'discount_given':
                text = <Trans>Discount Given</Trans>;
                break;
            case 'discount_received':
                text = <Trans>Discount Received</Trans>;
                break;
            case 'exchange_loss':
                text = <Trans>Exchange Loss</Trans>;
                break;
            case 'rounding_loss':
                text = <Trans>Rounding Loss</Trans>;
                break;
            case 'my_epf_control':
                text = <Trans>EPF Control</Trans>;
                break;
            case 'my_socso_control':
                text = <Trans>SOCSO Control</Trans>;
                break;
            case 'my_eis_control':
                text = <Trans>EIS Control</Trans>;
                break;
            case 'my_mtd_control':
                text = <Trans>MTD Control</Trans>;
                break;
            case 'my_zakat_control':
                text = <Trans>Zakat Control</Trans>;
                break;
            case 'my_payroll_adhoc_control':
                text = <Trans>Payroll Adhoc Expense</Trans>;
                break;
            case 'my_salary_control':
                text = <Trans>Salary Control</Trans>;
                break;
            case 'goods_received_not_invoiced':
                text = <Trans>Goods Received Not Invoiced</Trans>;
                break;
            case 'my_epf_expense':
                text = <Trans>EPF Expense</Trans>;
                break;
            case 'my_socso_expense':
                text = <Trans>SOCSO Expense</Trans>;
                break;
            case 'my_eis_expense':
                text = <Trans>EIS Expense</Trans>;
                break;
            case 'my_salary_expense':
                text = <Trans>Salary Expense</Trans>;
                break;
            case 'my_mtd_expense':
                text = <Trans>MTD Expense</Trans>;
                break;
            case 'depreciation':
                text = <Trans>Depreciation</Trans>;
                break;
            case 'my_sst_payable':
                text = <Trans>SST Payable</Trans>;
                break;
            case 'my_sst_deferred':
                text = <Trans>SST Deferred</Trans>;
                break;
            case 'my_sst_expense':
                text = <Trans>SST Expense</Trans>;
                break;
            case 'stock_opening':
                text = <Trans>Stock Opening</Trans>;
                break;
            case 'stock_closing':
                text = <Trans>Stock Closing</Trans>;
                break;
            default:
                break;
        }

        if (text)
            return text;
        return null;
    }
}
